// Models
import BinStatus from '../model/binStatus';
import SearchBin from '../model/searchBin';

import {
    FETCH_BIN_SUCCESS,
    FETCH_BIN_ERROR,
    HIDE_BIN_LOADER,
    SHOW_BIN_LOADER,
    UPLOAD_BIN_FILE_REQUEST,
    UPLOAD_BIN_FILE_SUCCESS,
    UPLOAD_BIN_FILE_ERROR,
    UPLOAD_NETWORK_BIN_FILE_REQUEST,
    UPLOAD_NETWORK_BIN_FILE_SUCCESS,
    UPLOAD_NETWORK_BIN_FILE_ERROR,
    SEARCH_BIN_DETAIL_SUCCESS,
    SEARCH_BIN_DETAIL_ERROR,
    UPDATE_BIN_DETAIL_SUCCESS,
    UPDATE_BIN_DETAIL_ERROR,
    GET_SEARCH_RECENT_BIN_SUCCESS,
    GET_SEARCH_RECENT_BIN_ERROR,
} from './manageBin.constants';

export const initialState = {
    tableData: [],
    tableDataSearch: [],
    searchedBin: {
        values: {},
        error: {},
    },
    staticData: {
        values: {},
        error: {},
    },
    pagination: {},
    error: {},
    isLoading: false,
    uploadFile: {
        isSuccess: false,
        message: '',
        isLoading: '',
        data: {},
    },
    uploadNetorkFile: {
        isSuccess: false,
        message: '',
        isLoading: '',
        data: {},
    },
    updateBin: {
        isSuccess: false,
        error: '',
    },
};

export const manageBinReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BIN_SUCCESS: {
            const binData = new BinStatus(action.payload);
            return {
                ...state,
                ...binData,
                error: {},
            };
        }
        case FETCH_BIN_ERROR:
            return {
                ...initialState,
                ...action.payload,
            };
        case SEARCH_BIN_DETAIL_SUCCESS: {
            const searchedBin = action.payload.cardBinRangeVO;
            return {
                ...state,
                searchedBin: {
                    values: { ...searchedBin },
                    error: {},
                },
            };
        }
        case SEARCH_BIN_DETAIL_ERROR:
            return {
                ...state,
                searchedBin: { ...action.payload },
            };
        case UPDATE_BIN_DETAIL_SUCCESS: {
            return {
                ...state,
                updateBin: { isSuccess: true, error: {} },
            };
        }
        case UPDATE_BIN_DETAIL_ERROR:
            return {
                ...state,
                updateBin: { isSuccess: false, ...action.payload },
            };
        case UPLOAD_BIN_FILE_REQUEST:
            return {
                ...state,
                uploadFile: { isSuccess: false, error: {} },
            };
        case UPLOAD_BIN_FILE_SUCCESS: {
            return {
                ...state,
                error: {},
                uploadFile: { isSuccess: true, error: {} },
            };
        }
        case UPLOAD_NETWORK_BIN_FILE_ERROR:
            return {
                ...state,
                uploadNetorkFile: {
                    isSuccess: false,
                    error: { ...action.payload },
                },
            };
        case UPLOAD_NETWORK_BIN_FILE_REQUEST:
            return {
                ...state,
                uploadNetorkFile: { isSuccess: false, error: {} },
            };
        case UPLOAD_NETWORK_BIN_FILE_SUCCESS: {
            return {
                ...state,
                error: {},
                uploadNetorkFile: { isSuccess: true, error: {} },
            };
        }
        case UPLOAD_BIN_FILE_ERROR:
            return {
                ...state,
                uploadFile: { isSuccess: false, error: { ...action.payload } },
            };
        case GET_SEARCH_RECENT_BIN_SUCCESS:
            const binData = new SearchBin(action.payload);
            return {
                ...state,
                ...binData,
                error: {},
            };
        case GET_SEARCH_RECENT_BIN_ERROR:
            return {
                ...state,
                ...action.payload,
                tableDataSearch: [],
            };

        case SHOW_BIN_LOADER:
            return { ...state, isLoading: true };
        case HIDE_BIN_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
